export type CurrencyCode = 'EUR' | 'USD' | 'GBP' | 'CHF' | 'AUD' | 'NZD';

const CURRENCY_SYMBOLS: Record<CurrencyCode, string> = {
  EUR: '€',
  USD: '$',
  GBP: '£',
  AUD: 'A$',
  NZD: 'NZ$',
  CHF: 'CHF',
};

export { CURRENCY_SYMBOLS };
